import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { QuestionRequest } from '../../requests/self-triage/question.request';
import { ListQuestionResponse } from '../../responses/self-triage/list-question.response';
import { QuestionResponse } from '../../responses/self-triage/question.response';

@Injectable({
  providedIn: 'root'
})
export class QuestionService extends CommonService {

  constructor(private httpClient: HttpClient,
    configService: AppConfigService,
private endpointBuilder: EndpointBuilderService) { super(configService); }

  public listQuestion(searchText: string, idFlowchart: number): Observable<ListQuestionResponse> {
    let uri = "Question/GetAll?"
    if (searchText)
      uri = uri + `searchText=${searchText}&`;
    if (idFlowchart)
      uri = uri + `idFlowchart=${idFlowchart}`;

    return this.httpClient.get<ListQuestionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public getQuestion(idQuestion: number): Observable<QuestionResponse> {
    let uri = `Question/idQuestion/${idQuestion}`

    return this.httpClient.get<QuestionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public deleteQuestion(idQuestion: number): Observable<ReturnStruct> {
    let uri = `Question/idQuestion/${idQuestion}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public createQuestion(question: QuestionRequest): Observable<QuestionResponse> {
    let uri = `Question`

    return this.httpClient.post<QuestionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, question, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateQuestion(idQuestion: number, question: QuestionRequest): Observable<QuestionResponse> {
    let uri = `Question/idQuestion/${idQuestion}`

    return this.httpClient.put<QuestionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, question, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
